
import React, { useState, useEffect } from 'react';
import { ViewState } from '../types';

interface HeroProps {
  setView: (view: ViewState) => void;
  customSrc?: string;
}

const Hero: React.FC<HeroProps> = ({ setView, customSrc }) => {
  const [heroSrc, setHeroSrc] = useState(customSrc || 'https://images.unsplash.com/photo-1541888946425-d81bb19480c5?q=80&w=2000&auto=format&fit=crop');
  const [errorState, setErrorState] = useState(0);

  useEffect(() => {
    if (customSrc) {
      setHeroSrc(customSrc);
      setErrorState(0);
    }
  }, [customSrc]);

  const handleHeroError = () => {
    const fallbacks = [
      'https://images.unsplash.com/photo-1581092160607-ee22621dd758?q=80&w=2000&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1590483734724-383b85ad0590?q=80&w=2000&auto=format&fit=crop'
    ];
    if (errorState < fallbacks.length) {
      setHeroSrc(fallbacks[errorState]);
      setErrorState(prev => prev + 1);
    }
  };

  return (
    <div className="relative w-full bg-slate-900 overflow-hidden">
      <div className="relative w-full min-h-[500px] sm:min-h-[600px] md:min-h-0 md:aspect-[21/9] lg:aspect-[25/10]">
        <img 
          src={heroSrc} 
          alt="Road Construction Excellence" 
          className="absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-1000"
          loading="eager"
          onError={handleHeroError}
        />
        
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-black/20"></div>

        <div className="absolute inset-0 flex items-center justify-center text-center px-6 py-20">
          <div className="max-w-4xl animate-in fade-in slide-in-from-bottom-8 duration-1000">
            <div className="text-blue-500 font-black text-xs sm:text-sm uppercase tracking-[0.4em] mb-4">Sai SSK Infrastructures</div>
            <h1 className="text-4xl sm:text-5xl md:text-7xl font-black text-white uppercase tracking-tighter leading-[0.9] mb-6">
              Engineering <span className="text-blue-500">Tomorrow's</span> Roads
            </h1>
            <p className="text-base sm:text-lg md:text-xl text-slate-300 font-medium mb-10 max-w-2xl mx-auto leading-relaxed">
              Sai SSK Infrastructures: 25 years of paving the way with precision, durability, and technological innovation.
            </p>
          </div>
        </div>
      </div>

      <div className="bg-blue-950 py-4 border-b-4 border-blue-600">
        <div className="max-w-7xl mx-auto px-4 flex justify-between md:justify-around items-center text-white/60 text-[10px] md:text-xs font-black tracking-[0.3em] uppercase">
          <span className="flex items-center gap-2"><span className="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></span> ISO 9001:2015</span>
          <span className="flex items-center gap-2"><span className="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></span> Government Grade A</span>
        </div>
      </div>
    </div>
  );
};

export default Hero;
